/**
 * Used to allow functions/classes to indicate that they should be registered as singletons with the container.
 */
export class SingletonRegistration {
    /**
     * Creates an instance of SingletonRegistration.
     * @param key The key to register as.
     */
    constructor(_key) {
        this._key = _key;
    }
    /**
     * Called by the container to register the resolver.
     * @param container The container the resolver is being registered with.
     * @param key The key the resolver should be registered as.
     * @param fn The function to create the resolver for.
     * @return The resolver that was registered.
     */
    registerResolver(container, key, fn) {
        const existingResolver = container.getResolver(this._key || key, false);
        return existingResolver === undefined
            ? container.registerSingleton(this._key || key, fn)
            : existingResolver;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2luZ2xldG9uUmVnaXN0cmF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiU2luZ2xldG9uUmVnaXN0cmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLHFCQUFxQjtJQUM5Qjs7O09BR0c7SUFDSCxZQUFvQyxJQUFhO1FBQWIsU0FBSSxHQUFKLElBQUksQ0FBUztJQUFHLENBQUM7SUFFckQ7Ozs7OztPQU1HO0lBQ0ksZ0JBQWdCLENBQUMsU0FBb0IsRUFBRSxHQUFXLEVBQUUsRUFBZTtRQUN0RSxNQUFNLGdCQUFnQixHQUFHLFNBQVMsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLElBQUksSUFBSSxHQUFHLEVBQUUsS0FBSyxDQUFDLENBQUM7UUFFeEUsT0FBTyxnQkFBZ0IsS0FBSyxTQUFTO1lBQ2pDLENBQUMsQ0FBQyxTQUFTLENBQUMsaUJBQWlCLENBQUMsSUFBSSxDQUFDLElBQUksSUFBSSxHQUFHLEVBQUUsRUFBRSxDQUFDO1lBQ25ELENBQUMsQ0FBQyxnQkFBZ0IsQ0FBQztJQUMzQixDQUFDO0NBQ0oifQ==